import { type CSSProperties } from "react";

const WORDMARK_DARK = "/assets/vocaler-wordmark.svg";
const WORDMARK_LIGHT = "/assets/vocaler-wordmark-light.svg";
const MARK = "/assets/vocaler-mark.svg";

export interface VocalerLogoProps {
  /** Target height in px. The wordmark aspect ratio is ~3.517. */
  size?: number;
  src?: string;
  className?: string;
  style?: CSSProperties;
}

/** Vocaler wordmark lockup. Swaps light/dark variant via [data-theme] in CSS. */
export function VocalerLogo({ size = 22, src, className = "", style }: VocalerLogoProps) {
  if (!src) {
    return (
      <span
        className={className}
        style={{
          display: "inline-block",
          position: "relative",
          height: size,
          width: size * 3.517,
          verticalAlign: "middle",
          ...style,
        }}
      >
        <img
          className="voc-logo-dark"
          src={WORDMARK_DARK}
          alt="vocaler"
          style={{ height: size, width: "auto", display: "block", position: "absolute", inset: 0 }}
        />
        <img
          className="voc-logo-light"
          src={WORDMARK_LIGHT}
          alt="vocaler"
          style={{ height: size, width: "auto", display: "none", position: "absolute", inset: 0 }}
        />
      </span>
    );
  }
  return (
    <img
      className={className}
      src={src}
      alt="vocaler"
      style={{
        height: size,
        width: "auto",
        display: "inline-block",
        verticalAlign: "middle",
        ...style,
      }}
    />
  );
}

export interface VocalerMarkProps {
  size?: number;
  src?: string;
  className?: string;
  style?: CSSProperties;
}

/** Standalone red dot mark. */
export function VocalerMark({ size = 24, src = MARK, className = "", style }: VocalerMarkProps) {
  return (
    <img
      className={className}
      src={src}
      alt="vocaler"
      style={{ width: size, height: size, display: "inline-block", ...style }}
    />
  );
}
